import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { GaTracker } from "@/components/GaTracker";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import { AdminAuthProvider } from "@/context/AdminAuth";
import { AdminLayout } from "@/components/admin/AdminLayout";
import Home from "@/pages/Home";
import Followers from "@/pages/Followers";
import Providers from "@/pages/Providers";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import Guides from "@/pages/Guides";
import GuideArticle from "@/pages/GuideArticle";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSubscribers from "@/pages/admin/AdminSubscribers";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminMt5 from "@/pages/admin/AdminMt5";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminMarketing from "@/pages/admin/AdminMarketing";
import AdminMailbox from "@/pages/admin/AdminMailbox";
import AdminProviders from "@/pages/admin/AdminProviders";
import AdminAudit from "@/pages/admin/AdminAudit";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [hash, pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <GaTracker />
        <AdminAuthProvider>
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="subscribers" element={<AdminSubscribers />} />
              <Route path="inbox" element={<AdminContacts />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="providers" element={<AdminProviders />} />
              <Route path="subscriptions" element={<AdminSubscriptions />} />
              <Route path="mt5" element={<AdminMt5 />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="marketing" element={<AdminMarketing />} />
              <Route path="mailbox" element={<AdminMailbox />} />
              <Route path="plans" element={<AdminPlans />} />
              <Route path="audit" element={<AdminAudit />} />
            </Route>

            {/* Marketing */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/followers" element={<Followers />} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:slug" element={<GuideArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:slug" element={<Legal />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{ style: { background: "#0A0A0B", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }}
      />
    </div>
  );
}

export default App;
